import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {of} from 'rxjs';
import { FireCollection } from 'src/app/constants/firestore-collection';
import { FirebaseService } from '../../services/firebase.service';
@Component({
  selector: 'app-customer-name',
  template: `<span>
  {{customerName}}
</span>`,
  styleUrls: ['./customer-name.component.scss']
})
export class CustomerNameComponent implements OnInit {
  customerName = 'Searching';
  @Input() customerId: string;
  constructor(private fireService: FirebaseService) {}
ngOnInit() {
 this.getCustomerName();
}

getCustomerName() {
  this.fireService.getDataById(FireCollection.CUSTOMER, this.customerId ).subscribe(res => {
    this.customerName =  res.data[0].firstName + ' ' + res.data[0].lastName;
  });
}
}
